import { getFolios, TableFolio } from "@csc-dashboard/api-client";
import { useEffect, useState } from "react";
import { useAlert } from "../context/alert";
import {
  AtTagFolioStatus,
  AtTagNumberVariant,
  AtTagType,
  MlTableMessage,
  OrTable,
  TableCellType,
  TableRow,
  TableType,
  formatDate,
  FORMAT_DATE_WITH_MONTH_NAME,
} from "@csc-dashboard/components-library";
import { useAdminPanel } from "../context/admin-panel";

export const FoliosContainer = () => {
  const size = 6;
  const { isGuest, setCurrentTab, foliosPage, setFoliosPage } = useAdminPanel();
  const { folios, loading, total } = useFolios(foliosPage, size);

  if (isGuest) {
    return (
      <MlTableMessage
        darkerDescription
        size="mini"
        title="Estás navegando en modo anónimo"
        description="No hay información del cliente que podamos mostrar."
      />
    );
  }

  const data: TableRow[] = folios.map((folio) => ({
    id: folio.folioNumber,
    cells: [
      {
        type: TableCellType.BADGE,
        tagProps: {
          type: AtTagType.NUMBER,
          variant: AtTagNumberVariant.FOLIO,
          label: folio.folioNumber,
        },
      },
      {
        type: TableCellType.BADGE,
        tagProps: {
          type: AtTagType.FOLIO,
          status: folio.status as AtTagFolioStatus,
        },
      },
      {
        type: TableCellType.TEXT,
        value: formatDate(folio.createdAt, FORMAT_DATE_WITH_MONTH_NAME),
      },
    ],
  }));

  const handleRowClick = (row: TableRow) => {
    setCurrentTab("folio-detail", {
      folioId: row.id,
    });
  };

  return (
    <div className="flex flex-col gap-4 flex-1">
      <OrTable
        className="flex-1"
        emptyStateConfig={{
          title: "No hay folios",
          description: "No hay folios para mostrar",
          size: "mini",
        }}
        onRowClick={handleRowClick}
        tableType={TableType.FOLIOS_MINI}
        isMini
        data={data}
        page={foliosPage}
        onPageChange={setFoliosPage}
        rowsPerPage={size}
        totalRows={total}
        loading={loading}
      ></OrTable>
    </div>
  );
};

const useFolios = (page: number, size: number) => {
  const [folios, setFolios] = useState<TableFolio[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);

  const { isGuest, userInfo } = useAdminPanel();
  const { showError } = useAlert();
  const customerEmail = userInfo?.email;

  useEffect(() => {
    const fetchFolios = async () => {
      try {
        setLoading(true);
        const { folios, totalPages, total } = await getFolios({
          page,
          size,
          customerEmail,
        });
        setFolios(folios);
        setTotalPages(totalPages);
        setTotal(total);
      } catch (error) {
        console.error(error);
        showError("Admin Panel: Error al obtener los folios");
      } finally {
        setLoading(false);
      }
    };
    if (!isGuest) {
      fetchFolios();
    }
  }, [page, size, showError, isGuest, customerEmail]);

  return {
    folios,
    loading,
    totalPages,
    total,
    page,
  };
};
